module.exports = __webpack_public_path__ + "static/media/find-your-center.aa7f08db.mp4";